var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import WindowConfigContext from '../../context/window-config-context';
import { convertToCSSValue, getTextAlignment } from '../../helpers/styles';
import ThemeContext from '../../context/theme-context';
var StyledListItem = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  position: ", ";\n"], ["\n  width: ", ";\n  height: ", ";\n  position: ", ";\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.list.item.width;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.list.item.height;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.list.item.position;
});
var StyledListItemValue = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var width = _a.width, height = _a.height, x = _a.x, alignment = _a.alignment;
    return "\n        position: " + function (_a) {
        var windowTheme = _a.windowTheme;
        return windowTheme.list.item.value.position;
    } + ";\n        width: " + convertToCSSValue(width) + ";\n        // height: " + convertToCSSValue(height) + ";\n        left: " + convertToCSSValue(x) + ";\n        top: " + function (_a) {
        var windowTheme = _a.windowTheme;
        return windowTheme.list.item.value.top;
    } + ";\n        " + getTextAlignment(alignment) + "\n    ";
});
var ListItemValue = function (props) {
    var propsValue = props.value, system = props.system, mode = props.mode, restProps = __rest(props, ["value", "system", "mode"]);
    var func = propsValue.func, from = propsValue.from, to = propsValue.to, speed = propsValue.speed, onComplete = propsValue.onComplete;
    var _a = useState(from || propsValue), value = _a[0], setValue = _a[1];
    return React.createElement(StyledListItemValue, __assign({}, restProps), value);
};
var ListItem = function (props) {
    var item = props.item, getWidget = props.getWidget, system = props.system;
    var animate = useContext(WindowConfigContext).animate;
    var mode = animate ? 'demo' : 'manual';
    var windowTheme = useContext(ThemeContext);
    return (React.createElement(StyledListItem, { windowTheme: windowTheme }, item.map(function (i) {
        var name = i.name, value = i.value;
        var headerLabelWidget = getWidget(name), attributes = headerLabelWidget.attributes, geometry = attributes.geometry, alignment = attributes.alignment;
        return (React.createElement(ListItemValue, __assign({ key: "" + name, value: value, system: system }, geometry, { alignment: alignment, mode: mode, windowTheme: windowTheme })));
    })));
};
export default ListItem;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Item.js.map